import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { SpinnerService } from '../../services/spinner.service';
import { DownloadService } from '../../services/download.service';
import { SnackbarService } from '../../services/snackbar.service';
import { FacturaGestorAcuerdoControllerService, FacturaAbonoDTO } from 'api-rest';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { DocumentService } from '../../services/document.service';
import { ManagersAgreementsInvoiceNewDocumentDialogComponent } from '../managers-agreements-invoice-document-dialog/managers-agreements-invoice-document-dialog.component';
import { ManagersAgreementsInvoiceRejectDialogComponent } from '../managers-agreements-invoice-reject-dialog/managers-agreements-invoice-reject-dialog.component';

@Component({
  selector: 'managers-agreements-managers-agreements-invoices-detail-dialog',
  templateUrl: './managers-agreements-invoices-detail-dialog.component.html',
  styleUrls: ['./managers-agreements-invoices-detail-dialog.component.scss']
})
export class ManagersAgreementsInvoicesDetailDialogComponent implements OnInit {

  modelForm!: FormGroup;
  documento: File | undefined;
  mustSeach: boolean = false;
  mostrarAbono: boolean = true;

  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private dialogRef: MatDialogRef<ManagersAgreementsInvoicesDetailDialogComponent>,
    private facturaGestorAcuerdoControllerService: FacturaGestorAcuerdoControllerService,
    private downloadService: DownloadService,
    private documentService: DocumentService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    @Inject(MAT_DIALOG_DATA) public factura: any,
  ) {
    this.cargaDatosAbono();
    this.inicializarForm();
  }

  ngOnInit() {
    this.cargaInicial();
  }

  inicializarForm() {
    this.modelForm = this.formBuilder.group({
      id: [{ value: this.factura?.id }],
      gestor: [{ value: `${this.factura?.gestoresResiduos?.nima} - ${this.factura?.gestoresResiduos?.razonSocial}`, disabled: true }],
      estado: [{ value: this.factura?.estado?.descripcion, disabled: true }],
      numeroPrefactura: [{ value: this.factura?.fechaAutofactura ? this.factura?.id : '', disabled: true }],
      fechaPrefactura: [{ value: this.factura?.fechaAutofactura, disabled: true }],
      numeroFactura: [{ value: this.factura?.numeroFactura, disabled: true }],
      fechaFactura: [{ value: this.factura?.fechaFactura, disabled: true }],
      registrada: [{ value: this.factura?.registrada, disabled: true }],
      importeAbono: [{ value: this.factura?.importeAbono, disabled: !!this.factura?.importeAbono }],
      cantidad: [{ value: this.factura?.cantidadAbonoKg, disabled: !!this.factura?.importeAbono }],
      motivoAbono: [{ value: this.factura?.motivoAbono, disabled: !!this.factura?.importeAbono }],
      numeroFacturaUipath: [{ value: this.factura?.numeroFacturaUipath, disabled: true }],
      fechaFacturaUipath: [{ value: this.factura?.fechaFacturaUipath, disabled: true }],
      poseedorUipath: [{ value: this.factura?.cifPoseedorUipath, disabled: true }],
      baseImponibleUipath: [{ value: this.factura?.baseImponibleUipath, disabled: true }],
      tipoIvaUipath: [{ value: this.factura?.tipoIVAUipath, disabled: true }],
      importeIvaUipath: [{ value: this.factura?.importeIVAUipath, disabled: true }],
      totalFacturaUipath: [{ value: this.factura?.totalFacturaUipath, disabled: true }],
      ibanUipath: [{ value: this.factura?.ibanUipath, disabled: true }],
      swiftUipath: [{ value: this.factura?.swiftUipath, disabled: true }],
    });
  }

  cargaInicial() {
    this.modelForm.disable();
    if (this.canViewResource('AI-ENV-GEST') && (this.factura?.importeAbono === null || this.factura?.importeAbono === undefined)) {
      this.modelForm.controls['importeAbono'].enable();
      this.modelForm.controls['cantidad'].enable();
      this.modelForm.controls['motivoAbono'].enable();
      this.mostrarAbono = true;
    } else if ((this.canViewResource('AI-APORT-AUTOFACT') || this.canViewResource('AI-GESTOR')) && (this.factura?.importeAbono !== null && this.factura?.importeAbono !== undefined)) {
      this.mostrarAbono = true;
    } else if ((this.canViewResource('AI-APORT-AUTOFACT') || this.canViewResource('AI-GESTOR')) && (this.factura?.importeAbono === null || this.factura?.importeAbono === undefined)) {
      this.mostrarAbono = false;
    }
  }

  closeDialog(): void {
    this.dialogRef.close(this.mustSeach);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.modelForm.controls[controlName].hasError(errorName) &&
      this.modelForm.controls[controlName].touched
    );
  }

  attachAdjunto(archivo: File | null): void {
    if (archivo) {
      if (archivo.size === 0) {
        this.snackBarSrv.showSnackBar(
          'No se puede subir un fichero vacío',
          'error'
        );
      } else if (archivo.size > 12 * 1024 * 1024) { // 12 MB
        this.snackBarSrv.showSnackBar(
          'El fichero supera el tamaño máximo permitido de 12 MB',
          'error'
        );
      } else {
        this.documento = archivo;
      }
    }
  }

  descargar(documento: any) {
    this.spinnerSrv.loadingShow();
    this.documentService.descargarDocumento(documento.id).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Se ha descargado el documento correctamente',
          'success'
        );
        this.downloadService.downloadBlob(response, documento.nombre);
      },
      error: () => {
        this.spinnerSrv.loadingHide();
      },
    });
  }

  descargarDetallePrefacturacion() {
    this.facturaGestorAcuerdoControllerService.prefacturaDetalle(this.factura?.id, 'response')
      .subscribe((res: any) => {
        const filename = this.downloadService.getFileName(
          res.headers,
          'Prefacturación.xlsx'
        );
        this.downloadService.downloadBlob(res.body!, filename!);
      });
  }

  canAccessAcceptInvoice() {
    const resultUpdateAccept = this.authService.can(
      'acuerdo-indirecto-facturas',
      'update-accept'
    );
    const estado2 = this.factura?.estado && this.factura?.estado.id === 2; //Facturada
    const estado5 = this.factura?.estado && this.factura?.estado.id === 5; //Pdte Revisión
    return resultUpdateAccept && (estado2 || estado5);
  }

  canRejectInvoice() {
    const resultReject = this.authService.can(
      'acuerdo-indirecto-facturas',
      'reject-factura'
    );
    const estado2 = this.factura?.estado && this.factura?.estado.id === 2; //Facturada
    const estado5 = this.factura?.estado && this.factura?.estado.id === 5; //Pdte Revisión
    return resultReject && (estado2 || estado5);
  }

  canAccessDonwloadInvoice() {
    const resultDownloadFactura = this.authService.can(
      'acuerdo-indirecto-facturas',
      'download-factura'
    );
    const estado2 = this.factura?.estado && this.factura?.estado.id === 2; //Facturada
    const estado3 = this.factura?.estado && this.factura?.estado.id === 3; //Aceptada
    const estado4 = this.factura?.estado && this.factura?.estado.id === 4; //Rechazada
    const estado5 = this.factura?.estado && this.factura?.estado.id === 5; //Pdte Revisión
    return (resultDownloadFactura || this.canViewResource('AI-ENV-CONS')) && (estado2 || estado3 || estado4 || estado5) && this.factura?.documento;
  }

  canAccessDonwloadSelfInvoice() {
    const resultDownloadAutofactura = this.authService.can(
      'acuerdo-indirecto-facturas',
      'download-autofactura'
    );
    return resultDownloadAutofactura || this.canViewResource('AI-ENV-CONS');
  }

  canAccessUpInvoice() {
    const resultUpFactura = this.authService.can(
      'acuerdo-indirecto-facturas',
      'update'
    );
    const estado1 = this.factura?.estado && this.factura?.estado.id === 1; //Pdte Factura
    const estado4 = this.factura?.estado && this.factura?.estado.id === 4; //Rechazada
    return resultUpFactura && (estado1 || estado4);
  }

  canAccessCrearAbono() {
    return this.canViewResource('AI-ENV-GEST') && (this.factura?.importeAbono === null || this.factura?.importeAbono === undefined);
  }

  canAccessRegistrate() {
    const resultRegistrate = this.authService.can(
      'acuerdo-indirecto-facturas-detalle',
      'registrar'
    );
    const estado3 = this.factura?.estado && this.factura?.estado.id === 3; 
    return resultRegistrate && estado3 && !this.factura?.registrada;
  }

  canViewRegistrada(): boolean {
    return this.authService.can('acuerdo-indirecto-facturas-detalle', 'view-registrada') || this.canViewResource('AI-ENV-CONS');
  }

  registrarFactura() {
    this.spinnerSrv.loadingShow();
    this.facturaGestorAcuerdoControllerService.registrarFactura(this.factura?.id)
      .subscribe({
        next: (res: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            `La factura se ha registrado correctamente`,
            'success'
          );
          this.actualizarRegistro();
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  openModalUploadInvoice(): void {
    const dialogRef = this.dialog.open(
      ManagersAgreementsInvoiceNewDocumentDialogComponent,
      {
        width: '650px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          itemOpen: this.factura,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.actualizarRegistro();
      }
    });
  }

  actualizarRegistro() {
    this.spinnerSrv.loadingShow();
    this.facturaGestorAcuerdoControllerService.getById(this.factura?.id)
      .subscribe({
        next: (data: any) => {
          this.spinnerSrv.loadingHide();
          if (data) {
            this.factura = data;
            this.inicializarForm();
            this.mustSeach = true;
          }
        },
        error: (error: any) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  aceptarFactura() {
    if (this.factura?.estado?.id === 5) {
      this.spinnerSrv.loadingShow();
      this.facturaGestorAcuerdoControllerService.actualizarEstado(this.factura?.id, 3).subscribe({
        next: (res: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Factura aceptada correctamente',
            'success'
          );
          this.actualizarRegistro();
        },
        error: (err: any) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Error al aceptar la factura',
            'error'
          );
        }
      });
    } else {
      this.confirmacionCambioEstado(this.factura?.id, 3);
    }
  }

  confirmacionCambioEstado(id?: any, estadoId?: any): void {
    Swal.fire({
      text: `¿Desea cambiar el estado del registro por Aceptada por Envalora?`,
      icon: 'question',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Sí',
      denyButtonText: 'No',
      allowOutsideClick: false,
    }).then((result: any) => {
      if (result.isConfirmed) {
        this.actualizarEstado(id, estadoId);
      }
    });
  }

  actualizarEstado(id?: any, estadoId?: any) {
    if (id && estadoId) {
      this.spinnerSrv.loadingShow();
      this.facturaGestorAcuerdoControllerService
        .actualizarEstado(id, estadoId)
        .subscribe({
          next: () => {
            this.spinnerSrv.loadingHide();
            this.snackBarSrv.showSnackBar(
              `El registro de factura se ha actualizado correctamente`,
              'success'
            );
            this.actualizarRegistro();
          },
          error: (err: { message: any }) => {
            this.spinnerSrv.loadingHide();
          },
        });
    }
  }

  openModalMotivoRechazo() {
    const dialogRef = this.dialog.open(
      ManagersAgreementsInvoiceRejectDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: this.factura,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.actualizarRegistro();
      }
    });
  }

  crearAbono() {
    let facturaAbonoDTO: FacturaAbonoDTO = {
      importeAbono: this.modelForm.get('importeAbono')?.value || 0,
      cantidadAbonoKg: this.modelForm.get('cantidad')?.value || 0,
      motivoAbono: this.modelForm.get('motivoAbono')?.value || ''
    };
    this.spinnerSrv.loadingShow();
    this.facturaGestorAcuerdoControllerService.crearAbono(this.factura?.id, facturaAbonoDTO)
      .subscribe({
        next: (data: any) => {
          this.spinnerSrv.loadingHide();
          if (data) {
            this.factura.importeAbono = data.importeAbono;
            this.factura.cantidadAbonoKg = data.cantidadAbonoKg;
            this.factura.motivoAbono = data.motivoAbono;
            this.inicializarForm();
            this.snackBarSrv.showSnackBar(
              `El abono se ha registrado correctamente`,
              'success'
            );
          }
        },
        error: (error: any) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  cargaDatosAbono() {
    this.facturaGestorAcuerdoControllerService.getById(this.factura?.id)
      .subscribe({
        next: (data: any) => {
          this.spinnerSrv.loadingHide();
          if (data) {
            this.factura.importeAbono = data.importeAbono;
            this.factura.cantidadAbonoKg = data.cantidadAbonoKg;
            this.factura.motivoAbono = data.motivoAbono;
          }
        },
        error: (error: any) => {
          this.spinnerSrv.loadingHide();
        },
      });
  }
}
